// @flow
import { useMemo } from 'react';
import range from 'ramda/es/range';

import SimpleDate from 'app/dataProviders/SimpleDate';


export default function useMonthDays(date: SimpleDate): Array<[number, boolean]> {
  const res = useMemo(() => {
    const monthday = date.getMonthDay();
    const weekDay = date.getWeekday();
    const firstSundayNum = (monthday - (weekDay + 1)) % 7;
    const firstSunday = firstSundayNum > 0 ? firstSundayNum : firstSundayNum + 7;

    return (
      range(1, date.getDaysInMonth() + 1)
        .map(day => ([day, day % 7 === firstSunday]))
    );
  }, [date]);

  return res;
}
